import { render } from "./AlignCenter.vue?vue&type=template&id=77ed0f72&scoped=true"
const script = {}

import "./AlignCenter.vue?vue&type=style&index=0&id=77ed0f72&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ed0f72"]])

export default __exports__